import React, { FC, use, useMemo } from "react";
import { ContactsContext } from "../../../../../scripts/context/ContactsContext";
import { ContactSelect } from "@app/components/shared/form/baseComponents/ContactSelect/ContactSelect";
import { Contacts, GQL } from "@binale-tech/shared";
import { useCanWrite } from "../../../../../scripts/infrastructure/hooks";
import { InvoiceFormInputTranslate } from "@inv/types";
import { useIntl } from "react-intl";

interface InvoiceContactProps {
    value?: string;
    onChange?: (value: string) => void;
}

export const InvoiceContact: FC<InvoiceContactProps> = ({ value, onChange }) => {
    const intl = useIntl();

    return (
        <ContactSelect
            value={value}
            onChange={onChange}
            placeholder={intl.formatMessage({ id: InvoiceFormInputTranslate.CONTACT })}
        />
    );
};
